module.exports = __webpack_public_path__ + "static/media/H15.661704f2.png";